export default {
    GET_EVENTS_REQUEST: 'GET_EVENTS_REQUEST',
    GET_EVENTS_SUCCESS: 'GET_EVENTS_SUCCESS',
    GET_EVENTS_FAILURE: 'GET_EVENTS_FAILURE',

    POST_EVENTS_REQUEST: 'POST_EVENTS_REQUEST',
    POST_EVENTS_SUCCESS: 'POST_EVENTS_SUCCESS',
    POST_EVENTS_FAILURE: 'POST_EVENTS_FAILURE',

    UPDATE_EVENTS_REQUEST: "UPDATE_EVENTS_REQUEST",
    UPDATE_EVENTS_SUCCESS: "UPDATE_EVENTS_SUCCESS",
    UPDATE_EVENTS_FAILURE: "UPDATE_EVENTS_FAILURE",

    DELETE_EVENTS_REQUEST: 'DELETE_EVENTS_REQUEST',
    DELETE_EVENTS_SUCCESS: 'DELETE_EVENTS_SUCCESS',
    DELETE_EVENTS_FAILURE: 'DELETE_EVENTS_FAILURE',

    GET_SLOT_SUMMARY_REQUEST: 'GET_SLOT_SUMMARY_REQUEST',
    GET_SLOT_SUMMARY_SUCCESS: 'GET_SLOT_SUMMARY_SUCCESS',
    GET_SLOT_SUMMARY_FAILURE: 'GET_SLOT_SUMMARY_FAILURE',

    UPDATE_SLOT_SUMMARY__REQUEST: "UPDATE_SLOT_SUMMARY__REQUEST",
    UPDATE_SLOT_SUMMARY__SUCCESS: "UPDATE_SLOT_SUMMARY__SUCCESS",
    UPDATE_SLOT_SUMMARY__FAILURE: "UPDATE_SLOT_SUMMARY__FAILURE",

    BLOCK_SLOT_SUMMARY__REQUEST: "BLOCK_SLOT_SUMMARY__REQUEST",
    BLOCK_SLOT_SUMMARY__SUCCESS: "BLOCK_SLOT_SUMMARY__SUCCESS",
    BLOCK_SLOT_SUMMARY__FAILURE: "BLOCK_SLOT_SUMMARY__FAILURE",

    GET_UNAVAILABILITY_REQUEST: 'GET_UNAVAILABILITY_REQUEST',
    GET_UNAVAILABILITY_SUCCESS: 'GET_UNAVAILABILITY_SUCCESS',
    GET_UNAVAILABILITY_FAILURE: 'GET_UNAVAILABILITY_FAILURE',

    POST_UNAVAILABILITY_REQUEST: 'POST_UNAVAILABILITY_REQUEST',
    POST_UNAVAILABILITY_SUCCESS: 'POST_UNAVAILABILITY_SUCCESS',
    POST_UNAVAILABILITY_FAILURE: 'POST_UNAVAILABILITY_FAILURE',

    DELETE_UNAVAILABILITY_REQUEST: 'DELETE_UNAVAILABILITY_REQUEST',
    DELETE_UNAVAILABILITY_SUCCESS: 'DELETE_UNAVAILABILITY_SUCCESS',
    DELETE_UNAVAILABILITY_FAILURE: 'DELETE_UNAVAILABILITY_FAILURE',

    GET_AVAILABILITY_REQUEST: 'GET_AVAILABILITY_REQUEST',
    GET_AVAILABILITY_SUCCESS: 'GET_AVAILABILITY_SUCCESS',
    GET_AVAILABILITY_FAILURE: 'GET_AVAILABILITY_FAILURE',

    POST_AVAILABILITY_REQUEST: 'POST_AVAILABILITY_REQUEST',
    POST_AVAILABILITY_SUCCESS: 'POST_AVAILABILITY_SUCCESS',
    POST_AVAILABILITY_FAILURE: 'POST_AVAILABILITY_FAILURE',

    UPDATE_AVAILABILITY_REQUEST: 'UPDATE_AVAILABILITY_REQUEST',
    UPDATE_AVAILABILITY_SUCCESS: 'UPDATE_AVAILABILITY_SUCCESS',
    UPDATE_AVAILABILITY_FAILURE: 'UPDATE_AVAILABILITY_FAILURE',

    MOVE_BULK_APPOINTEMNTS_REQUEST: "MOVE_BULK_APPOINTEMNTS_REQUEST",
    MOVE_BULK_APPOINTEMNTS_SUCCESS: "MOVE_BULK_APPOINTEMNTS_SUCCESS",
    MOVE_BULK_APPOINTEMNTS_FAILURE: "MOVE_BULK_APPOINTEMNTS_FAILURE",

    UNBLOCK_SLOT_SUMMARY_REQUEST: "UNBLOCK_SLOT_SUMMARY_REQUEST",
    UNBLOCK_SLOT_SUMMARY_SUCCESS: "UNBLOCK_SLOT_SUMMARY_SUCCESS",
    UNBLOCK_SLOT_SUMMARY_FAILURE: "UNBLOCK_SLOT_SUMMARY_FAILURE",

    CANCEL_BULK_APPOINTMENTS_REQUEST: 'CANCEL_BULK_APPOINTMENTS_REQUEST',
    CANCEL_BULK_APPOINTMENTS_SUCCESS: 'CANCEL_BULK_APPOINTMENTS_SUCCESS',
    CANCEL_BULK_APPOINTMENTS_FAILURE: 'CANCEL_BULK_APPOINTMENTS_FAILURE',

    GET_TIMELINE_REQUEST: 'GET_TIMELINE_REQUEST',
    GET_TIMELINE_SUCCESS: 'GET_TIMELINE_SUCCESS',
    GET_TIMELINE_FAILURE: 'GET_TIMELINE_FAILURE',
};
